module.exports = __webpack_public_path__ + "img/img_3dfield_powerflow1.7566f592.svg";